import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  input,
  signal,
  viewChild,
} from "@angular/core";
import { TypeDashboard } from "../../enums/dashboard-type.enum";
import { DashboardComponent } from "../../components/dashboard/dashboard.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../../../shared/shared.module";
import { DashboardFacadeService } from "../../services/dashboard-facade.service";
import { WidgetDataFacadeService } from "../../services/widget-data-facade.service";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DialogsService } from "../../../../shared/services/dialogs/dialogs.service";
import { DisplayService } from "../../../home/services/display.service";
import { ArticlesModule } from "../../../articles/articles.module";
import { DashboardSettingsPanelComponent } from "../dashboard-settings-panel/dashboard-settings-panel.component";
import { JustupPageComponent } from "../../../../shared/components/justup-page/justup-page.component";
import { BigButtonComponent } from "../../../../shared/components/big-button/big-button.component";

@Component({
  selector: "vl-dashboard-container",
  standalone: true,
  imports: [
    DashboardComponent,
    MatTooltipModule,
    CommonModule,
    SharedModule,
    ArticlesModule,
    JustupPageComponent,
    BigButtonComponent,
  ],
  templateUrl: "./dashboard-container.component.html",
  styleUrls: ["./dashboard-container.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardContainerComponent {
  dialogService = inject(DialogsService);
  displayService = inject(DisplayService);
  private dashboardFacade = inject(DashboardFacadeService);
  private widgetDataFacade = inject(WidgetDataFacadeService);

  refreshing = signal(false);

  customLoading = input<boolean>(false);
  containerRef = viewChild<ElementRef>("container");
  containerElement = computed(() => {
    const el = this.containerRef()?.nativeElement;
    return el?.closest(".justup-page-main-content") ?? el;
  });

  rowHeight = input<number>(150);

  type = input<TypeDashboard>();

  dashboard = this.dashboardFacade.getState().dashboard;
  editable = input<boolean>(true);

  constructor() {
    effect(() => {
      this.dashboardFacade.loadDashboard(this.type());
    });
  }

  openSettings() {
    this.dialogService.openPanel(DashboardSettingsPanelComponent, {
      type: this.type(),
    });
  }

  /** Vide le cache widget côté back et recharge tous les widgets affichés. */
  async onRefresh() {
    if (this.refreshing()) return;
    this.refreshing.set(true);
    try {
      await this.widgetDataFacade.refreshAll();
    } finally {
      this.refreshing.set(false);
    }
  }
}
